import { React } from 'react';

function Capacitive(props) {
  return (
    <div className="project-content-container" id="capacitive-project-content-container">
      <div className="project-content-container-section project-overview">
        <h1>Overview</h1>
        <p>This project involved building a circuit that used capacitive touch to control a computer. A user would draw a custom controller on paper with a pencil and hook it up to the circuit with several paper clip connectors. They would touch the pencil-shaded sections of their controller to send signals to control the computer.</p>
      </div>
    </div>
  );
}

export default Capacitive;